import { BaseAppService } from '@/shared/app/BaseAppService';
import { useMeetingStore } from '../../host/stores/meeting.store';
import { MeetingRoomState } from '../../shared/interfaces/meeting-service.interface';

/**
 * AppService manages event logic for this application.
 * - Register all event listeners in `registerEventListeners()`
 * - Emit events using `emit{EventName}Event()`
 * - Handle events using private `handle{EventName}` methods
 */
export class AppService extends BaseAppService {
  init() {}

  isInMeeting(): boolean {
    return useMeetingStore.getState().meetingRoomState == MeetingRoomState.JOINED;
  }

  /**
   * Leaves the current meeting through setCurrentRoomId('') rather than the
   * raw leaveMeeting() store action — only setCurrentRoomId's own leave
   * branch actually emits vo.meeting.leave (via MeetingEventRouter). The raw
   * action tears down the Jitsi connection but silently skips that event,
   * which left the activity-metrics "meeting" dimension never closing.
   */
  async leaveMeeting(): Promise<any> {
    return useMeetingStore.getState().setCurrentRoomId('');
  }

  /**
   * Joins (or rejoins) a room through setCurrentRoomId — same reasoning as
   * leaveMeeting() above, for vo.meeting.join: the raw joinMeetingRoom()
   * store action never emits it, only setCurrentRoomId's join branch does.
   */
  async joinMeeting(roomPid: string): Promise<any> {
    return useMeetingStore.getState().setCurrentRoomId(roomPid);
  }
}
